import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { Box, Grid2 } from "@mui/material";
import PieChartCard from "./graphs/PieChartCard";
import { useNavigate, useParams } from "react-router";
import WeekdayChart from "./graphs/WeekdayChart";
import { DateTime } from "luxon";
import HolidayChart from "./graphs/HolidayChart";
import ScatterPlot from "./graphs/ScatterPlot";
import MultiChartCard from "./graphs/MultiChartCard";
import DataGridCard from "./DataGridCard";
import TotalChart from "./graphs/FullTotalCard";
import Text from "../../genericComponents/Text";
import { AccountBalance, ElectricMeter, GasMeter, LocationCity } from "@mui/icons-material";
const OrganizationAnalysis = ({ setHeader }) => {    
    const currentYear=DateTime.now().toObject().year;
        const [start, setStart] = useState(DateTime.utc(currentYear, 1, 1))
        const [end, setEnd] = useState(DateTime.utc(currentYear, 12, 31))
    const params = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        setHeader({ icon: AccountBalance, text: params.name });
    }, [setHeader, params.name])    
    const id = params.id;
    const chartHeight = 390;

    const charts = [        
        { name: (<Grid2 container spacing={1}><ElectricMeter /><Text text={"i18n_chart_total"} /></Grid2>), graph: <TotalChart start={start} end={end} level={"ORGANIZATION"} meterType={"ELECTRICITY"} id={id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><ElectricMeter /><Text text={"i18n_chart_weekday"} /></Grid2>), graph: <WeekdayChart start={start} end={end} level={"ORGANIZATION"} meterType={"ELECTRICITY"} id={id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><ElectricMeter /><Text text={"i18n_chart_holiday"} /></Grid2>), graph: <HolidayChart start={start} end={end} level={"ORGANIZATION"} meterType={"ELECTRICITY"} id={id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><ElectricMeter /><Text text={"i18n_chart_temperature"} /></Grid2>), graph: <ScatterPlot start={start} end={end} level={"ORGANIZATION"} meterType={"ELECTRICITY"} id={id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><GasMeter /><Text text={"i18n_chart_total"} /></Grid2>), graph: <TotalChart  start={start} end={end} level={"ORGANIZATION"} meterType={"GAS"} id={id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><GasMeter /><Text text={"i18n_chart_weekday"} /></Grid2>), graph: <WeekdayChart start={start} end={end} level={"ORGANIZATION"} meterType={"GAS"} id={id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><GasMeter /><Text text={"i18n_chart_holiday"} /></Grid2>), graph: <HolidayChart start={start} end={end} level={"ORGANIZATION"} meterType={"GAS"} id={id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><GasMeter /><Text text={"i18n_chart_temperature"} /></Grid2>), graph: <ScatterPlot start={start} end={end} level={"ORGANIZATION"} meterType={"GAS"} id={id} height={chartHeight} /> },    
    ]
    const defaultFilters = [{ propertyName: "organizationId", comparator: "eq", value: params.id }];
    return (<Box sx={{ flexGrow: 1 }}>
        <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12 }}>
                <PieChartCard start={start} end={end} level={"ORGANIZATION"} id={id} />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
                <MultiChartCard  start={start} setStart={setStart} setEnd={setEnd} end={end} title="i18n_analysis" graphs={charts} height={chartHeight} />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
                <DataGridCard
                    icon={LocationCity}
                    pageSize={5}
                    title={"i18n_buildings"}
                    defaultFilters={defaultFilters}
                    defaultColumns={["displayName", "usage", "energyLabel", "rental", "floorSize", "buildingYear", "climateType"]}
                    onClick={item => navigate("/analysis/building/" + item.displayName + "/" + item.uuid)}
                    type="buildings" />
            </Grid2>
        </Grid2>
    </Box>)
}
export default OrganizationAnalysis